<template>
  <div>
    <b-form-group
      id="input-group-date-from"
      label="Desde:"
      label-for="input-date-from"
    >
      <b-form-datepicker
        id="input-date-from"
        :value="dateFrom"
        :min="minDateFrom"
        :max="maxDateFrom"
        start-weekday="1"
        menu-class="w-100"
        calendar-width="100%"
        value-as-date
        :required="required"
        @input="(event) => $emit('update-date-from', event)"
      />
    </b-form-group>
    <b-form-group
      id="input-group-date-to"
      label="Hasta:"
      label-for="input-date-to"
    >
      <b-form-datepicker
        id="input-date-to"
        :value="dateTo"
        :min="minDateTo"
        :max="maxDateTo"
        start-weekday="1"
        menu-class="w-100"
        calendar-width="100%"
        value-as-date
        :required="required"
        @input="(event) => $emit('update-date-to', event)"
      />
    </b-form-group>
  </div>
</template>

<script>

import DateRangeComposition from '@/app/shared/compositions/DateRange'

export default {
  name: 'BaseDateRange',
  props: {
    dateFrom: {
      type: Date,
      required: true
    },
    dateTo: {
      type: Date,
      required: true
    },
    futureDateRange: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const { minDateFrom, minDateTo, maxDateFrom, maxDateTo } = DateRangeComposition(props)
    return {
      minDateFrom,
      minDateTo,
      maxDateFrom,
      maxDateTo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/shared/components/BaseDateRange.vue